import { render } from "./ConsentModalToggle.vue?vue&type=template&id=5d276939&scoped=true"
import script from "./ConsentModalToggle.vue?vue&type=script&lang=js"
export * from "./ConsentModalToggle.vue?vue&type=script&lang=js"

import "./ConsentModalToggle.vue?vue&type=style&index=0&id=5d276939&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d276939"]])

export default __exports__